
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexF9fSWWLSS7462JnhlDw4rYG1e5ZQGYalNeOQA6RNmsMMeta } from "/vercel/path0/apps/be.unity.org/app/pages/index.ts?macro=true";
import { default as startghP5x_45lrU24wBj_45RAImThEKDh90gB9TVapIXLsRSg8QMeta } from "/vercel/path0/apps/be.unity.org/app/pages/start.ts?macro=true";
import { default as favoritesmJn7B1wlka278hmvZ3awO6lF_SfWmrkXFUGSoqcTCwMMeta } from "/vercel/path0/apps/be.unity.org/app/pages/favorites.vue?macro=true";
import { default as error0GJ5qe3w051SUO_7gT_45R14lu0uR6AH8cMx7k5Ls01ikMeta } from "/vercel/path0/apps/be.unity.org/app/pages/auth/error.vue?macro=true";
import { default as preferencesB_v6UnTJQHefRgBooFVOu_45i6qCa53ac9_45CGCbyIGoYAMeta } from "/vercel/path0/apps/be.unity.org/app/pages/preferences.vue?macro=true";
import { default as auth9uVPW4ZPY0Hi00DAcZQmYvBC1xKd7100pNIAavCXr9gMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/auth.vue?macro=true";
import { default as installT_45sxNFtx52kViVfcmPcv0AJDlRDqsoipSA9dxHBE4JoMeta } from "/vercel/path0/apps/be.unity.org/app/pages/help/install.vue?macro=true";
import { default as indexpTZPpNrHE0yXZi6Jo1mQk3fxJkuLNDajDcQFhiwr4x8Meta } from "/vercel/path0/apps/be.unity.org/app/pages/prayer/index.vue?macro=true";
import { default as submitRxnxeiQIxtEs0mzZbsz1SlPl8LvhXL68_45d4wD1tVf3AMeta } from "/vercel/path0/apps/be.unity.org/app/pages/prayer/submit.vue?macro=true";
import { default as colorsUZv6IyCOnYu4j_45iTB9YYOEPFy57ymk4EtMZLBOyA9YEMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/colors.vue?macro=true";
import { default as splashlQVccUsF6NseN3u62PWOpBwsywA4NZYclfWONrHGL8sMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/splash.vue?macro=true";
import { default as jsonapitsv7EBdW6xfPuegtO_VGiRnFtBLMgB_zgj4YTQfUoBEMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/jsonapi.vue?macro=true";
import { default as indexsdwRvTrthfEmqtJMOx2eADYCFoxGOyOzuP4t3jySE9UMeta } from "/vercel/path0/apps/be.unity.org/app/pages/daily-word/index.ts?macro=true";
import { default as pickridoxTsVPWBkwZAVhijdTTcuaCie3_45IuUIDmZf_NpwcMeta } from "/vercel/path0/apps/be.unity.org/app/pages/daily-word/pick.vue?macro=true";
import { default as _91name_93b6SejXRpzWJvV0QZztuzdQ23KymVT88QvVF_45T7ugabMMeta } from "/vercel/path0/apps/be.unity.org/app/pages/playlist/[name].vue?macro=true";
import { default as thank_45youRrA4E2YCVrH7Lc_45IUBcnp0GJI0syNYSrSXYM3e9bg3IMeta } from "/vercel/path0/apps/be.unity.org/app/pages/prayer/thank-you.vue?macro=true";
import { default as _91date_93CEaCeODc19gTDbCHW3ifUPk_451zPGlIyW5sNfhwl7W2kMeta } from "/vercel/path0/apps/be.unity.org/app/pages/daily-word/[date].vue?macro=true";
import { default as date_45input1tKOLVdHQup_k2BIj1TmftJrb_45NtKOVlGuweOtECbgEMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/date-input.vue?macro=true";
import { default as notifications4T9_45IeIJM_453VyNTfMyDoV4btcVgulbWjWFEMrMCmHGAMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/notifications.vue?macro=true";
import { default as subscriptionsJZLLvtu1ecBF64KHiJn2MX8DzCqyy_45h7HjIDb_M57SoMeta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/subscriptions.vue?macro=true";
import { default as infinite_45scrollkpISNcP57pU_45ui06WZmRC5lFvzocgy2_45_45AA3g7h9fN0Meta } from "/vercel/path0/apps/be.unity.org/app/pages/tester/infinite-scroll.vue?macro=true";
import { default as component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.13.1_@upstash+red_1394b70abd98536012376ec3d35499b7/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.13.1_@upstash+red_1394b70abd98536012376ec3d35499b7/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/index.ts")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/index.ts")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/index.ts")
  },
  {
    name: "start___en___default",
    path: "/start",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/start.ts")
  },
  {
    name: "start___en",
    path: "/en/start",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/start.ts")
  },
  {
    name: "start___es",
    path: "/es/start",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/start.ts")
  },
  {
    name: "favorites___en___default",
    path: "/favorites",
    meta: favoritesmJn7B1wlka278hmvZ3awO6lF_SfWmrkXFUGSoqcTCwMMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/favorites.vue")
  },
  {
    name: "favorites___en",
    path: "/en/favorites",
    meta: favoritesmJn7B1wlka278hmvZ3awO6lF_SfWmrkXFUGSoqcTCwMMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/favorites.vue")
  },
  {
    name: "favorites___es",
    path: "/es/favorites",
    meta: favoritesmJn7B1wlka278hmvZ3awO6lF_SfWmrkXFUGSoqcTCwMMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/favorites.vue")
  },
  {
    name: "auth-error___en___default",
    path: "/auth/error",
    meta: error0GJ5qe3w051SUO_7gT_45R14lu0uR6AH8cMx7k5Ls01ikMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/auth/error.vue")
  },
  {
    name: "auth-error___en",
    path: "/en/auth/error",
    meta: error0GJ5qe3w051SUO_7gT_45R14lu0uR6AH8cMx7k5Ls01ikMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/auth/error.vue")
  },
  {
    name: "auth-error___es",
    path: "/es/auth/error",
    meta: error0GJ5qe3w051SUO_7gT_45R14lu0uR6AH8cMx7k5Ls01ikMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/auth/error.vue")
  },
  {
    name: "preferences___en___default",
    path: "/preferences",
    meta: preferencesB_v6UnTJQHefRgBooFVOu_45i6qCa53ac9_45CGCbyIGoYAMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/preferences.vue")
  },
  {
    name: "preferences___en",
    path: "/en/preferences",
    meta: preferencesB_v6UnTJQHefRgBooFVOu_45i6qCa53ac9_45CGCbyIGoYAMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/preferences.vue")
  },
  {
    name: "preferences___es",
    path: "/es/preferences",
    meta: preferencesB_v6UnTJQHefRgBooFVOu_45i6qCa53ac9_45CGCbyIGoYAMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/preferences.vue")
  },
  {
    name: "tester-auth___en___default",
    path: "/tester/auth",
    meta: auth9uVPW4ZPY0Hi00DAcZQmYvBC1xKd7100pNIAavCXr9gMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/auth.vue")
  },
  {
    name: "tester-auth___en",
    path: "/en/tester/auth",
    meta: auth9uVPW4ZPY0Hi00DAcZQmYvBC1xKd7100pNIAavCXr9gMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/auth.vue")
  },
  {
    name: "tester-auth___es",
    path: "/es/tester/auth",
    meta: auth9uVPW4ZPY0Hi00DAcZQmYvBC1xKd7100pNIAavCXr9gMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/auth.vue")
  },
  {
    name: "help-install___en___default",
    path: "/help/install",
    meta: installT_45sxNFtx52kViVfcmPcv0AJDlRDqsoipSA9dxHBE4JoMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/help/install.vue")
  },
  {
    name: "help-install___en",
    path: "/en/help/install",
    meta: installT_45sxNFtx52kViVfcmPcv0AJDlRDqsoipSA9dxHBE4JoMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/help/install.vue")
  },
  {
    name: "help-install___es",
    path: "/es/help/install",
    meta: installT_45sxNFtx52kViVfcmPcv0AJDlRDqsoipSA9dxHBE4JoMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/help/install.vue")
  },
  {
    name: "prayer___en___default",
    path: "/prayer",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/index.vue")
  },
  {
    name: "prayer___en",
    path: "/en/prayer",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/index.vue")
  },
  {
    name: "prayer___es",
    path: "/es/prayer",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/index.vue")
  },
  {
    name: "prayer-submit___en___default",
    path: "/prayer/submit",
    meta: submitRxnxeiQIxtEs0mzZbsz1SlPl8LvhXL68_45d4wD1tVf3AMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/submit.vue")
  },
  {
    name: "prayer-submit___en",
    path: "/en/prayer/submit",
    meta: submitRxnxeiQIxtEs0mzZbsz1SlPl8LvhXL68_45d4wD1tVf3AMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/submit.vue")
  },
  {
    name: "prayer-submit___es",
    path: "/es/prayer/submit",
    meta: submitRxnxeiQIxtEs0mzZbsz1SlPl8LvhXL68_45d4wD1tVf3AMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/submit.vue")
  },
  {
    name: "tester-colors___en___default",
    path: "/tester/colors",
    meta: colorsUZv6IyCOnYu4j_45iTB9YYOEPFy57ymk4EtMZLBOyA9YEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/colors.vue")
  },
  {
    name: "tester-colors___en",
    path: "/en/tester/colors",
    meta: colorsUZv6IyCOnYu4j_45iTB9YYOEPFy57ymk4EtMZLBOyA9YEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/colors.vue")
  },
  {
    name: "tester-colors___es",
    path: "/es/tester/colors",
    meta: colorsUZv6IyCOnYu4j_45iTB9YYOEPFy57ymk4EtMZLBOyA9YEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/colors.vue")
  },
  {
    name: "tester-splash___en___default",
    path: "/tester/splash",
    meta: splashlQVccUsF6NseN3u62PWOpBwsywA4NZYclfWONrHGL8sMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/splash.vue")
  },
  {
    name: "tester-splash___en",
    path: "/en/tester/splash",
    meta: splashlQVccUsF6NseN3u62PWOpBwsywA4NZYclfWONrHGL8sMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/splash.vue")
  },
  {
    name: "tester-splash___es",
    path: "/es/tester/splash",
    meta: splashlQVccUsF6NseN3u62PWOpBwsywA4NZYclfWONrHGL8sMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/splash.vue")
  },
  {
    name: "tester-jsonapi___en___default",
    path: "/tester/jsonapi",
    meta: jsonapitsv7EBdW6xfPuegtO_VGiRnFtBLMgB_zgj4YTQfUoBEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/jsonapi.vue")
  },
  {
    name: "tester-jsonapi___en",
    path: "/en/tester/jsonapi",
    meta: jsonapitsv7EBdW6xfPuegtO_VGiRnFtBLMgB_zgj4YTQfUoBEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/jsonapi.vue")
  },
  {
    name: "tester-jsonapi___es",
    path: "/es/tester/jsonapi",
    meta: jsonapitsv7EBdW6xfPuegtO_VGiRnFtBLMgB_zgj4YTQfUoBEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/jsonapi.vue")
  },
  {
    name: "daily-word___en___default",
    path: "/daily-word",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/index.ts")
  },
  {
    name: "daily-word___en",
    path: "/en/daily-word",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/index.ts")
  },
  {
    name: "daily-word___es",
    path: "/es/daily-word",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/index.ts")
  },
  {
    name: "daily-word-pick___en___default",
    path: "/daily-word/pick",
    meta: pickridoxTsVPWBkwZAVhijdTTcuaCie3_45IuUIDmZf_NpwcMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/pick.vue")
  },
  {
    name: "daily-word-pick___en",
    path: "/en/daily-word/pick",
    meta: pickridoxTsVPWBkwZAVhijdTTcuaCie3_45IuUIDmZf_NpwcMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/pick.vue")
  },
  {
    name: "daily-word-pick___es",
    path: "/es/daily-word/pick",
    meta: pickridoxTsVPWBkwZAVhijdTTcuaCie3_45IuUIDmZf_NpwcMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/pick.vue")
  },
  {
    name: "playlist-name___en___default",
    path: "/playlist/:name()",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/playlist/[name].vue")
  },
  {
    name: "playlist-name___en",
    path: "/en/playlist/:name()",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/playlist/[name].vue")
  },
  {
    name: "playlist-name___es",
    path: "/es/playlist/:name()",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/playlist/[name].vue")
  },
  {
    name: "prayer-thank-you___en___default",
    path: "/prayer/thank-you",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/thank-you.vue")
  },
  {
    name: "prayer-thank-you___en",
    path: "/en/prayer/thank-you",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/thank-you.vue")
  },
  {
    name: "prayer-thank-you___es",
    path: "/es/prayer/thank-you",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/prayer/thank-you.vue")
  },
  {
    name: "daily-word-date___en___default",
    path: "/daily-word/:date()",
    meta: _91date_93CEaCeODc19gTDbCHW3ifUPk_451zPGlIyW5sNfhwl7W2kMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/[date].vue")
  },
  {
    name: "daily-word-date___en",
    path: "/en/daily-word/:date()",
    meta: _91date_93CEaCeODc19gTDbCHW3ifUPk_451zPGlIyW5sNfhwl7W2kMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/[date].vue")
  },
  {
    name: "daily-word-date___es",
    path: "/es/la-palabra-diaria/:date()",
    meta: _91date_93CEaCeODc19gTDbCHW3ifUPk_451zPGlIyW5sNfhwl7W2kMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/daily-word/[date].vue")
  },
  {
    name: "tester-date-input___en___default",
    path: "/tester/date-input",
    meta: date_45input1tKOLVdHQup_k2BIj1TmftJrb_45NtKOVlGuweOtECbgEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/date-input.vue")
  },
  {
    name: "tester-date-input___en",
    path: "/en/tester/date-input",
    meta: date_45input1tKOLVdHQup_k2BIj1TmftJrb_45NtKOVlGuweOtECbgEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/date-input.vue")
  },
  {
    name: "tester-date-input___es",
    path: "/es/tester/date-input",
    meta: date_45input1tKOLVdHQup_k2BIj1TmftJrb_45NtKOVlGuweOtECbgEMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/date-input.vue")
  },
  {
    name: "tester-notifications___en___default",
    path: "/tester/notifications",
    meta: notifications4T9_45IeIJM_453VyNTfMyDoV4btcVgulbWjWFEMrMCmHGAMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/notifications.vue")
  },
  {
    name: "tester-notifications___en",
    path: "/en/tester/notifications",
    meta: notifications4T9_45IeIJM_453VyNTfMyDoV4btcVgulbWjWFEMrMCmHGAMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/notifications.vue")
  },
  {
    name: "tester-notifications___es",
    path: "/es/tester/notifications",
    meta: notifications4T9_45IeIJM_453VyNTfMyDoV4btcVgulbWjWFEMrMCmHGAMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/notifications.vue")
  },
  {
    name: "tester-subscriptions___en___default",
    path: "/tester/subscriptions",
    meta: subscriptionsJZLLvtu1ecBF64KHiJn2MX8DzCqyy_45h7HjIDb_M57SoMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/subscriptions.vue")
  },
  {
    name: "tester-subscriptions___en",
    path: "/en/tester/subscriptions",
    meta: subscriptionsJZLLvtu1ecBF64KHiJn2MX8DzCqyy_45h7HjIDb_M57SoMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/subscriptions.vue")
  },
  {
    name: "tester-subscriptions___es",
    path: "/es/tester/subscriptions",
    meta: subscriptionsJZLLvtu1ecBF64KHiJn2MX8DzCqyy_45h7HjIDb_M57SoMeta || {},
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/subscriptions.vue")
  },
  {
    name: "tester-infinite-scroll___en___default",
    path: "/tester/infinite-scroll",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/infinite-scroll.vue")
  },
  {
    name: "tester-infinite-scroll___en",
    path: "/en/tester/infinite-scroll",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/infinite-scroll.vue")
  },
  {
    name: "tester-infinite-scroll___es",
    path: "/es/tester/infinite-scroll",
    component: () => import("/vercel/path0/apps/be.unity.org/app/pages/tester/infinite-scroll.vue")
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/help",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/en/help",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/es/help",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/pray",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/en/pray",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/es/pray",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/today",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/en/today",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  },
  {
    name: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBYMeta?.name,
    path: "/es/today",
    component: component_45stubx65bI30RwsGisWtqxcQs4ov_45gKCwBwRs1hJY_45dAteBY
  }
]